import type { StrapiResponseModel } from '@/interfaces/model';
import type { StrapiListResponse } from '@/interfaces/strapi';

import type { ProductCatalogModel } from '@/interfaces/model/product-catalog.model';
import type { ProductCatalog } from '@/interfaces/strapi/product-catalog.interface';
import { catalogCategoryMapper } from '@/mappers';
import { mapImage } from '@/helpers/strapi-assets-helpers';

export const productCatalogMapper = (p: ProductCatalogModel): ProductCatalog => ({
	id: p.documentId,
	name: p.name,
	slug: p.slug,
	author: p.author,
	editorial: p.editorial,
	year: p.year,
	isbn: p.isbn,
	price: p.price,
	category: p.categoria
		? catalogCategoryMapper(p.categoria)
		: {
				id: 'unknown',
				name: 'Sin categoría',
				slug: 'sin-categoria',
			},
	image: p.image ? mapImage(p.image, 'full') : { url: '', alt: p.name },
});

/** Mappea una respuesta paginada de productos */
export const productCatalogListMapper = (
	res: StrapiResponseModel<ProductCatalogModel>,
): StrapiListResponse<ProductCatalog> => {
	const list = (res.data ?? []).map(productCatalogMapper);

	const pagination = res.meta?.pagination ?? {
		page: res.meta.pagination.page,
		pageSize: list.length,
		pageCount: res.meta.pagination.pageCount,
		total: list.length,
	};

	return { list, pagination };
};
